import { render } from "./CloverPaywall.vue?vue&type=template&id=5fc80a32&scoped=true"
import script from "./CloverPaywall.vue?vue&type=script&lang=js"
export * from "./CloverPaywall.vue?vue&type=script&lang=js"

import "./CloverPaywall.vue?vue&type=style&index=0&id=5fc80a32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc80a32"]])

export default __exports__